import React from "react";
import {motion} from "framer-motion";

/**
 * A motion.div that wraps a child element. When active is true the box shadow plays a pulsing animation
 * @param active a boolean that determines if the animation is played
 * @param pulseDuration the length of the animation
 * @param children the child element wrapped by this component
 * @param additionalStyle additional style passed as a jsx style object added to both the active and inactive styles, meaning it will always use this additional style.
 * @returns {Element}
 * @constructor
 */
export default function PulsingDivWrapper({active, pulseDuration = 2, children, additionalStyle}) {

    const activeStyle = {
        boxShadow: "0 0 0px 4px #BEDDFD",
        borderRadius: "5px",
        height: '100%',
        width: '100%',
        ...additionalStyle
    }

    const inactiveStyle = {
        boxShadow: "0 0 0px 4px rgba(0,0,0,0)",
        borderRadius: "5px",
        height: '100%',
        width: '100%',
        ...additionalStyle
    }

    const activeAnims = {
        boxShadow: [
            "0 0 0px 4px #BEDDFD", // shown
            "0 0 0px 0px #BEDDFD", // hidden
            "0 0 0px 4px #BEDDFD", // shown
        ],
    }

    const activeTransition = {
        duration: pulseDuration,
        ease: "easeInOut",
        repeat: Infinity, // Loop infinitely
        repeatType: "loop", // Repeats the loop animation
    }

    return (
    <motion.div
        style={active ? activeStyle : inactiveStyle}
        animate={active ? activeAnims : {}}
        transition={active ? activeTransition : {duration: 0}}
    >
        {children}
    </motion.div>
    )
}